module.exports = __webpack_public_path__ + "static/media/team-Pe.1f32d894.png";